angular.module('unergie.main')
.controller('feesAffectationModalCtrl', ($scope, $uibModalInstance, $filter, ApiBilling, AlertManager, ErrorCatcher) => {
    $scope.close = $uibModalInstance.dismiss

    $scope.id_prm = ''

    $scope.searchFees = function () {
        $scope.searchingFees = true
        const search = {}
        if ($scope.id_prm) {
            search.id_prm = $scope.id_prm
        }
        return ApiBilling.unaffectedFees(search).$promise.then((data) => {
            $scope.fees = data
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.searchingFees = false
        })
    }

    $scope.affectFee = (fee) => {
        fee.affecting = true
        return ApiBilling.affectFee({ id: fee.id }, { id_contract: fee.id_contract, status: 'INITIAL' }).$promise.then(() => {
            AlertManager.success(`Affectée !`)
            $scope.searchFees()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            fee.affecting = false
        })
    }

    $scope.computeFee = (fee) => {
        return (fee.amount_tax_exc * (1 + (fee.vat_rate / 100)))
    }

    $scope.formatContract = (c) => {
        let lbl = `${c.id} - ${$filter('contractStatus')(c.status)}`
        if (c.commissioning_date) {
            lbl += ` - de ${moment(c.commissioning_date).format('DD/MM/YYYY')}`
        }
        if (c.decommissioning_date) {
            lbl += ` à ${moment(c.decommissioning_date).format('DD/MM/YYYY')}`
        }
        return lbl
    }

    $scope.done = $uibModalInstance.close
})
